module.exports = __webpack_public_path__ + "img/hepicon-iphone.f724089e.png";